import { render, staticRenderFns } from "./Cn-COA-OilShxto.vue?vue&type=template&id=9b04b21e&scoped=true&"
import script from "./Cn-COA-OilShxto.vue?vue&type=script&lang=js&"
export * from "./Cn-COA-OilShxto.vue?vue&type=script&lang=js&"
import style0 from "./Cn-COA-OilShxto.vue?vue&type=style&index=0&id=9b04b21e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b04b21e",
  null
  
)

export default component.exports